import { buildProps, definePropType } from '@ll-plus/utils'

export type IModalType = 'textarea' | 'code' | 'batch'

export const apiModalProps = buildProps({
  type: {
    type: definePropType<IModalType>(String),
    default: 'textarea'
  },
  open: {
    type: Boolean,
    default: false
  },
  value: {
    type: String,
    default: ''
  }
} as const)

export const apiModalEmits = {
  'update:open': (open: boolean) => !!open,
  'update:value': (value: string) => !!value,
  ok: (value: string) => !!value
}
